import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useDevice } from "./context/DeviceContext";

function UpcomingEvents() {
  const { isMobile } = useDevice();
  const [eventsData, setEventsData] = useState([]);
  const [upcomingIssuesData, setUpcomingIssuesData] = useState([]);
  const [forthcomingListingData, setForthcomingListingData] = useState([]);
  const [forthcomingOfsData, setForthcomingOfsData] = useState([]);
  const [upcomingTenderData, setUpcomingTenderData] = useState([]);
  const [economicCalenderData, setEconomicCalenderData] = useState([]);
  const [priceBandChangeData, setPriceBandChangeData] = useState([]);
  const [seriesChangeData, setSeriesChangeData] = useState([]);
  const [creditRatingData, setCreditRatingData] = useState([]);
  

  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('events'); // 🔹 tracks which tab is active
  const [marketCapFilter, setMarketCapFilter] = useState(false);
  const [selectedKeyword, setSelectedKeyword] = useState(null); // or null if nothing selected
  const [periodFilter, setPeriodFilter] = useState(null); // "today" | "next3days" | null
  const [selectedSeries, setSelectedSeries] = useState(null);
  const [selectedIndustries, setSelectedIndustries] = useState([]);
  const [industryFilterOpen, setIndustryFilterOpen] = useState(false);
  const [industrySearch, setIndustrySearch] = useState('');
  
  const [sortConfigs, setSortConfigs] = useState({
    events: { key: 'date', direction: 'asc' },
    upcomingIssues: { key: 'date', direction: 'desc' },
    forthcomingListing: { key: 'date', direction: 'asc' },
    forthcomingOfs: { key: 'date', direction: 'asc' },
    economicCalender: { key: 'date', direction: 'desc' },
    upcomingTender: { key: 'date', direction: 'asc' },
    priceBandChange: { key: 'marketCap', direction: 'desc' }
  });
  

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/events`)
      .then(res => {
        setEventsData(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to fetch events', err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/upcomingIssues`)
      .then(res => {
        setUpcomingIssuesData(res.data);
      })
      .catch(err => {
        console.error('Failed to fetch upcomingIssuesData', err);
      });
  }, []);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/forthcomingListing`)
      .then(res => {
        setForthcomingListingData(res.data);
      })
      .catch(err => {
        console.error('Failed to fetch forthcomingListingData', err);
      });
  }, []);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/forthcomingOfs`)
      .then(res => {
        setForthcomingOfsData(res.data);
      })
      .catch(err => {
        console.error('Failed to fetch forthcomingOfs', err);
      });
  }, []);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/upcomingTender`)
      .then(res => {
        setUpcomingTenderData(res.data);
      })
      .catch(err => {
        console.error('Failed to fetch upcomingTender', err);
      });
  }, []);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/economicCalender`)
      .then(res => {
        setEconomicCalenderData(res.data);
      })
      .catch(err => {
        console.error('Failed to fetch economicCalender', err);
      });
  }, []);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/priceBandChange`)
      .then(res => {
        setPriceBandChangeData(res.data);
      })
      .catch(err => {
        console.error('Failed to fetch priceBandChange', err);
      });
  }, []);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/seriesChange`)
      .then(res => {
        setSeriesChangeData(res.data);
      })
      .catch(err => {
        console.error('Failed to fetch seriesChange', err);
      });
  }, []);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/creditRatings`)
      .then(res => {
        setCreditRatingData(res.data);
      })
      .catch(err => {
        console.error('Failed to fetch seriesChange', err);
      });
  }, []);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return isNaN(date) ? 'Invalid date' : date.toLocaleDateString('en-IN');
  };

  const getChange = (curr, prev) => {
    if (isNaN(curr) || isNaN(prev) || prev === 0) return '—';

    const change = ((curr - prev) / prev) * 100;
    const colorClass = change >= 0 ? 'text-green-600' : 'text-red-600';

    return (
      <span className={`font-semibold ${colorClass}`}>
        {change.toFixed(2)}%
      </span>
    );
  };

  const renderSortableHeader = (label, columnKey, tabKey) => {
    const config = sortConfigs[tabKey];

    const handleSort = () => {
      setSortConfigs((prev) => ({
        ...prev,
        [tabKey]: {
          key: columnKey,
          direction:
            prev[tabKey].key === columnKey && prev[tabKey].direction === 'asc'
              ? 'desc'
              : 'asc',
        },
      }));
    };

    return (
      <th
        className="p-2 cursor-pointer select-none text-blue-600"
        onClick={handleSort}
      >
        {label}
        {config.key === columnKey
          ? config.direction === 'asc'
            ? ' ↑'
            : ' ↓'
          : ''}
      </th>
    );
  };

  const allSeriesOptions = [
    ...new Set(
      upcomingIssuesData
        .filter((item) => item.series)
        .map((item) => item.series)
    ),
  ];

  const getIndustries = (industry) => {
    if (!industry) return [];

    const value = String(industry).trim();

    if (["N", "NEW"].includes(value.toUpperCase()))
      return [];

    return value
      .split("/")
      .map((x) => x.trim())
      .filter(Boolean);
  };

  const allIndustryOptions = [
    ...new Set(
      eventsData.flatMap((row) => getIndustries(row.industry))
    ),
  ].sort();

  const filteredIndustryOptions = allIndustryOptions.filter((industry) =>
    industry.toLowerCase().includes(industrySearch.toLowerCase())
  );

  const renderIndustry = (industry) => {
    const industries = getIndustries(industry);

    if (!industries.length)
      return "—";

    return (
      <div className="flex flex-wrap gap-1">
        {industries.map((name) => (
          <span
            key={name}
            className="inline-block bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full"
          >
            {name}
          </span>
        ))}
      </div>
    );
  };

  const filteredEventsData = eventsData.filter((row) => {
    const text = `${row.purpose || ''}`.toLowerCase();
    const marketCap = parseFloat(row.marketCap ?? 0);

    const rowIndustries = getIndustries(row.industry);

    const industryMatch =
      selectedIndustries.length === 0 ||
      selectedIndustries.some((industry) =>
        rowIndustries.includes(industry)
      );


    const keywordMatch = selectedKeyword
      ? text.includes(selectedKeyword.toLowerCase())
      : true;

    const marketCapMatch = marketCapFilter
      ? marketCap > 800 * 1e7
      : true;

    const eventDate = row.date ? new Date(row.date) : null;
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    
    const dateMatch =
      periodFilter === 'today'
        ? eventDate && eventDate.toDateString() === today.toDateString()
        : periodFilter === 'yesterday'
        ? eventDate && eventDate.toDateString() === yesterday.toDateString()
        : periodFilter === 'next3days'
        ? eventDate >= today &&
          eventDate <= new Date(today.getTime() + 3 * 24 * 60 * 60 * 1000)
        : true;

    return keywordMatch && marketCapMatch && dateMatch && industryMatch;
  });

  const enrichedEventsData = filteredEventsData.map(row => {
    const curr = parseFloat(row.currentPrice);
    const prev = parseFloat(row.previousClose);
    const change = !isNaN(curr) && !isNaN(prev) && prev !== 0
      ? ((curr - prev) / prev) * 100
      : null;

    return { ...row, change };
  });

  const sortedEventsData = [...enrichedEventsData].sort((a, b) => {
    const { key, direction } = sortConfigs.events;
    const dir = direction === 'asc' ? 1 : -1;

    if (key === 'change') {
      const valA = isNaN(a.change) ? -Infinity : a.change;
      const valB = isNaN(b.change) ? -Infinity : b.change;
      return dir * (valA - valB);
    }

    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    return dir * (dateA - dateB);
  });

  const sortedEconomicCalenderData = [...economicCalenderData].sort((a, b) => {
    const { key, direction } = sortConfigs.economicCalender;
    const dir = direction === 'asc' ? 1 : -1;

    if (key === 'date') {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dir * (dateA - dateB);
    }

    return 0;
  });

  const filteredUpcomingIssueData = (data, selectedSeries) => {
    return data.filter((item) => {
      const seriesMatch = selectedSeries ? item.series === selectedSeries : true;

      return seriesMatch;
    });
  };

  const enrichedUpcomingIssues = filteredUpcomingIssueData(upcomingIssuesData, selectedSeries).map(row => {
    const size = parseFloat((row.issueSize || '').toString().replace(/,/g, ''));
    const priceMatch = (row.issuePrice || '').match(/(\d+(\.\d+)?)(?!.*\d)/); // last number
    const price = priceMatch ? parseFloat(priceMatch[1]) : null;

    const totalSize = (!isNaN(size) && !isNaN(price)) ? (size * price) / 1e7 : null;
    return { ...row, totalSize };
  });

  const sortedUpcomingIssuesData = [...enrichedUpcomingIssues].sort((a, b) => {
    const { key, direction } = sortConfigs.upcomingIssues;
    const dir = direction === 'asc' ? 1 : -1;

    if (key === 'totalSize') {
      const valA = isNaN(a.totalSize) ? -Infinity : a.totalSize;
      const valB = isNaN(b.totalSize) ? -Infinity : b.totalSize;
      return dir * (valA - valB);
    }

    if (key === 'date') {
      const dateA = new Date(a.issueEndDate);
      const dateB = new Date(b.issueEndDate);
      return dir * (dateA - dateB);
    }

    return 0;
  });

  const enrichedForthcomingOfs = forthcomingOfsData.map(row => {
    const size = parseFloat((row.issueSize || '').toString().replace(/,/g, ''));
    const price = parseFloat((row.floorPrice || '').toString().replace(/,/g, ''));
    const totalSize = (!isNaN(size) && !isNaN(price)) ? (size * price) / 1e7 : null;
    return { ...row, totalSize };
  });

  const sortedForthcomingOfsData = [...enrichedForthcomingOfs].sort((a, b) => {
    const { key, direction } = sortConfigs.forthcomingOfs;
    const dir = direction === 'asc' ? 1 : -1;

    if (key === 'totalSize') {
      const valA = isNaN(a.totalSize) ? -Infinity : a.totalSize;
      const valB = isNaN(b.totalSize) ? -Infinity : b.totalSize;
      return dir * (valA - valB);
    }

    if (key === 'date') {
      const dateA = new Date(a.endDate);
      const dateB = new Date(b.endDate);
      return dir * (dateA - dateB);
    }

    return 0;
  });

  // ------------------------ Upcoming Tender --------------------------------
const enrichedUpcomingTenderData = upcomingTenderData.map(row => {
  const size = parseFloat((row.issueSize || '').toString().replace(/,/g, ''));

  // ✅ tenders show "band" in UI, so use that for price
  // fallback to floorPrice if band missing
  const priceStr = (row.band ?? row.floorPrice ?? '').toString();
  const price = parseFloat(priceStr.replace(/,/g, ''));

  const totalSize =
    (!isNaN(size) && !isNaN(price)) ? (size * price) / 1e7 : null;

  return { ...row, totalSize };
});


const sortedUpcomingTenderData = [...enrichedUpcomingTenderData].sort((a, b) => {
  // ✅ use upcomingTender sort config (not forthcomingOfs)
  const { key, direction } = sortConfigs.upcomingTender;
  const dir = direction === 'asc' ? 1 : -1;

  if (key === 'totalSize') {
    const valA = isNaN(a.totalSize) ? -Infinity : a.totalSize;
    const valB = isNaN(b.totalSize) ? -Infinity : b.totalSize;
    return dir * (valA - valB);
  }

  if (key === 'date') {
    // ✅ tender uses todEndDate as closing date (per your table)
    const dateA = new Date(a.todEndDate);
    const dateB = new Date(b.todEndDate);
    return dir * (dateA - dateB);
  }

  return 0;
});


  // ----------------------- Economic Calender ------------------------------
  const sortedForthcomingListingData = [...forthcomingListingData].sort((a, b) => {
    const { key, direction } = sortConfigs.forthcomingListing;
    const dir = direction === 'asc' ? 1 : -1;

    if (key === 'date') {
      const dateA = new Date(a.effectiveDate);
      const dateB = new Date(b.effectiveDate);
      return dir * (dateA - dateB);
    }

    return 0;
  });

  const flagMap = {
    India: "🇮🇳",
    China: "🇨🇳",
    Japan: "🇯🇵",
    "Euro Area": "🇪🇺",
    USA: "🇺🇸"
  };

  const impactClasses = {
    low: "bg-green-100 text-green-800",
    medium: "bg-yellow-100 text-yellow-800",
    high: "bg-red-100 text-red-800",
  };

  const [expandedRow, setExpandedRow] = useState(null); // only one row at a time
  const toggleRow = (key) => {
    setExpandedRow((prev) => (prev === key ? null : key));
  };

  // --------------------------------------------------
  // Price Band Change - Sorting
  // --------------------------------------------------

  const sortedPriceBandChangeData = [...priceBandChangeData].sort((a, b) => {
    const { key, direction } = sortConfigs.priceBandChange;
    const dir = direction === 'asc' ? 1 : -1;

    const toNumber = (value) => {
      if (value == null || String(value).trim() === "") {
        return null;
      }

      const num = Number(String(value).replace(/,/g, ""));
      return Number.isFinite(num) ? num : null;
    };

    const getValue = (row) => {
      if (key === 'marketCap') {
        return toNumber(row.marketCap);
      }

      if (key === 'change') {
        const from = toNumber(row["FROM"]);
        const to = toNumber(row["TO"]);

        return from != null && to != null
          ? to - from
          : null;
      }

      return null;
    };

    const valA = getValue(a);
    const valB = getValue(b);

    // Keep missing values at the bottom
    if (valA == null && valB == null) return 0;
    if (valA == null) return 1;
    if (valB == null) return -1;

    return dir * (valA - valB);
  });

  return (
    <div className="p-4 mb-4">
      {/* 🔹 Navbar Tabs */}
      <div className="flex flex-wrap gap-3 border-b mb-4 ml-1">
        {['events', 'upcomingIssues', 'forthcomingListing', 
          'forthcomingOfs','upcomingTender', 'economicCalender', 'priceBandChange', 'seriesChange', 'creditRating' ].map(tab => (
          <a
            href="#"
            key={tab}
            style={{ marginRight: '1rem' }}  // 👈 1rem = 16px
            onClick={(e) => {
              e.preventDefault();
              setActiveTab(tab);
            }}
            className={`inline-block mr-4 pb-2 px-2 text-sm font-medium transition duration-150 ease-in-out border-b-2 ${
              activeTab === tab
                ? 'border-blue-600 text-blue-600 font-semibold'
                : 'border-transparent text-gray-500 hover:text-blue-500 hover:border-blue-300'
            }`}
          >
            {tab === 'events' ? 'Stock Events' :
             tab === 'upcomingIssues' ? 'Upcoming Issues' :
             tab === 'forthcomingListing' ? 'Upcoming Listings':
             tab === 'forthcomingOfs' ? 'Upcoming OFS':
             tab === 'upcomingTender'? 'Upcoming Tenders':
             tab === 'priceBandChange' ? 'Price Band Changes' :
             tab === 'seriesChange' ? 'Series Changes' :
             tab === 'creditRating' ? 'Credit Ratings' :
             'Economic Calender'
             }
          </a>
        ))}
      </div>

      {/* 🔹 Events */}
      {activeTab === 'events' && (
        <>
          {loading ? (
            <div className="text-center text-blue-600">Loading...</div>
          ) : (
            <>
            <div className="mb-4">
              <div className="flex flex-wrap gap-2 mb-2">
                <span className="text-gray-600 text-sm">Sub : </span>
                {["Financial Results", "Stock Split", "Bonus", "Dividend", "Fund Raising"].map(keyword => (
                  <button
                    key={keyword}
                    onClick={() =>
                      setSelectedKeyword(selectedKeyword === keyword ? null : keyword)
                    }
                    className={`px-3 py-1 text-xs rounded-full border ${
                      selectedKeyword === keyword ? 'bg-green-300 text-black font-semibold' : 'bg-gray-200'
                    }`}
                  >
                    {keyword}
                  </button>
                ))}
              </div>

              <div className="flex flex-wrap gap-2 mb-3">
                <span className="text-gray-600 text-sm">Period : </span>
                {["yesterday", "today", "next3days"].map((label) => (
                  <button
                    key={label}
                    onClick={() =>
                      setPeriodFilter(periodFilter === label ? null : label)
                    }
                    className={`px-3 py-1 text-xs rounded-full border font-medium ${
                      periodFilter === label
                        ? 'bg-indigo-300 text-black'
                        : 'bg-indigo-100 text-gray-800'
                    }`}
                  >
                    {label === 'yesterday'
                      ? 'Yesterday'
                      : label === 'today'
                      ? 'Today'
                      : 'Next 3 Days'}
                  </button>
                ))}

                {/* <button
                  onClick={() => setMarketCapFilter(!marketCapFilter)}
                  className={`px-3 py-1 text-xs rounded-full border ${
                    marketCapFilter ? 'bg-green-300 text-black font-semibold' : 'bg-gray-200'
                  }`}
                >
                  Market Cap &gt; 800 Cr
                </button> */}
              </div>

              {!isMobile && (
                <div className="mb-3 flex items-center gap-2">
                  <span className="text-sm text-gray-600 whitespace-nowrap">
                    Filter Industry:
                  </span>

                  <div className="relative">
                    <button
                      type="button"
                      onClick={() => setIndustryFilterOpen((v) => !v)}
                      className="
                        inline-flex
                        items-center
                        gap-2
                        px-3
                        py-1.5
                        text-sm
                        text-gray-700
                        bg-gray-50
                        border
                        border-gray-200
                        rounded-full
                        hover:bg-gray-100
                        hover:border-gray-300
                        transition
                      "
                    >
                      <span>
                        {selectedIndustries.length > 0
                          ? `${selectedIndustries.length} selected`
                          : "Select Industry"}
                      </span>

                      <span className="text-[10px] text-gray-400">
                        {industryFilterOpen ? "▲" : "▼"}
                      </span>
                    </button>

                    {industryFilterOpen && (
                      <div
                        className="
                          absolute
                          left-0
                          top-full
                          mt-2
                          w-[290px]
                          bg-white
                          border
                          border-gray-200
                          rounded-xl
                          shadow-xl
                          z-50
                          overflow-hidden
                        "
                      >
                        {/* Search */}
                        <div className="p-2.5 border-b border-gray-100">
                          <input
                            type="text"
                            value={industrySearch}
                            onChange={(e) => setIndustrySearch(e.target.value)}
                            placeholder="Search industry..."
                            className="
                              w-full
                              px-3
                              py-2
                              text-sm
                              bg-gray-50
                              border
                              border-gray-200
                              rounded-lg
                              outline-none
                              focus:bg-white
                              focus:border-blue-400
                            "
                          />
                        </div>

                        {/* Select All / Clear */}
                        <div className="flex justify-between items-center px-3 py-2 border-b border-gray-100">
                          <button
                            type="button"
                            onClick={() =>
                              setSelectedIndustries(filteredIndustryOptions)
                            }
                            className="text-xs font-medium text-blue-600 hover:text-blue-700"
                          >
                            Select All
                          </button>

                          <button
                            type="button"
                            onClick={() => setSelectedIndustries([])}
                            className="text-xs text-gray-500 hover:text-gray-700"
                          >
                            Clear
                          </button>
                        </div>

                        {/* Industry options */}
                        <div className="max-h-64 overflow-y-auto py-1">
                          {filteredIndustryOptions.map((industry) => {
                            const selected = selectedIndustries.includes(industry);

                            return (
                              <label
                                key={industry}
                                className={`
                                  flex
                                  items-center
                                  gap-2
                                  px-3
                                  py-2
                                  text-sm
                                  cursor-pointer
                                  ${
                                    selected
                                      ? "bg-blue-50"
                                      : "hover:bg-gray-50"
                                  }
                                `}
                              >
                                <input
                                  type="checkbox"
                                  checked={selected}
                                  onChange={() =>
                                    setSelectedIndustries((prev) =>
                                      selected
                                        ? prev.filter((x) => x !== industry)
                                        : [...prev, industry]
                                    )
                                  }
                                  className="h-4 w-4 rounded border-gray-300"
                                />

                                <span className="truncate text-gray-700">
                                  {industry}
                                </span>
                              </label>
                            );
                          })}

                          {filteredIndustryOptions.length === 0 && (
                            <div className="px-3 py-4 text-sm text-gray-400 text-center">
                              No industries found
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="text-sm text-gray-600">
                Total rows {sortedEventsData.length}
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="table-auto border-collapse w-full text-sm text-gray-800 font-normal">
                <thead>
                  <tr className="bg-gray-200">
                    {renderSortableHeader('Date', 'date', 'events')}

                    <th className="p-2 text-left">
                      Company
                    </th>

                    <th className="p-2 text-left">
                      Industry
                    </th>

                    {renderSortableHeader('Change', 'change', 'events')}

                    <th className="p-2 text-left">
                      Purpose
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sortedEventsData.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center text-gray-500 py-4">
                        No matching events found.
                      </td>
                    </tr>
                  ) : (
                    sortedEventsData.map((row, idx) => (
                      <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-100'}>
                        <td className="p-2">{formatDate(row.date)}</td>

                        <td className="p-2">
                          <a
                            href={`symbol/${row.symbol}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 underline"
                          >
                            {row.company || '—'}
                          </a>
                        </td>

                        <td className="p-2">
                          {renderIndustry(row.industry)}
                        </td>

                        <td className="p-2">
                          {getChange(row.currentPrice, row.previousClose)}
                        </td>
                        <td className="p-2">{row.purpose || '—'}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            </>
          )}
        </>
      )}

      {/* 🔹 Upcoming Issues */}
      {activeTab === 'upcomingIssues' && (
        <>
        <div className="mb-4 flex flex-wrap gap-2 items-center">
          <span className="text-gray-600 text-sm">Series:</span>
          {allSeriesOptions.map((seriesVal) => (
            <button
              key={seriesVal}
              onClick={() =>
                setSelectedSeries((prev) => (prev === seriesVal ? null : seriesVal))
              }
              className={`px-3 py-1 text-xs rounded-full border ${
                selectedSeries === seriesVal
                  ? 'bg-blue-500 text-white font-semibold'
                  : 'bg-gray-100 text-gray-800'
              }`}
            >
              {seriesVal}
            </button>
          ))}
        </div>

        <div className="overflow-x-auto">
          <table className="table-auto border-collapse w-full text-sm text-gray-800 font-normal">
            <thead className="bg-gray-200 text-left sticky top-0 z-40">
              <tr>
                <th className="p-2 sticky left-0 bg-gray-200 z-50">Company</th>
                <th className="p-2 text-left">Issue Type</th>
                <th className="p-2 text-left">Opening Date</th>
                {renderSortableHeader('Closing Date', 'date', 'upcomingIssues')}
                <th className="p-2 text-left">Status</th>
                <th className="p-2 text-left">Issue Size</th>
                <th className="p-2 text-left">Issue Price</th>
                {renderSortableHeader('Total Size', 'totalSize', 'upcomingIssues')}
                <th className="p-2 text-left">Is BSE</th>
              </tr>
            </thead>
            <tbody>
              {sortedUpcomingIssuesData.map((item, idx) => (
                <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-100'}>
                  <td className="p-2 sticky left-0 bg-inherit z-10 font-medium">{item.companyName || '—'}</td>
                  <td className="p-2">{item.series || '—'}</td>
                  <td className="p-2">{formatDate(item.issueStartDate)}</td>
                  <td className="p-2">{formatDate(item.issueEndDate)}</td>
                  <td className="p-2">{item.status || '—'}</td>
                  <td className="p-2">{item.issueSize || '—'}</td>
                  <td className="p-2">{item.issuePrice || '—'}</td>

                  {/* 🔸 Computed Total Size in Cr */}
                  <td className="p-2 font-medium">
                    {(() => {
                      const size = parseFloat((item.issueSize || '').toString().replace(/,/g, ''));
                      const priceMatch = (item.issuePrice || '').match(/(\d+(\.\d+)?)(?!.*\d)/); // get last number
                      const price = priceMatch ? parseFloat(priceMatch[1]) : null;

                      if (!isNaN(size) && !isNaN(price)) {
                        const total = (size * price) / 1e7;
                        return `₹${total.toFixed(2)} Cr`;
                      }
                      return '—';
                    })()}
                  </td>
                  <td className="p-2">{item.isBse > 0 ? "Yes" : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        </>
      )}

      {/* 🔹 Forthcoming Listing*/}
      {activeTab === 'forthcomingListing' && (
      <>
        <div className="overflow-x-auto">
          <table className="table-auto border-collapse w-full text-sm text-gray-800 font-normal">
            <thead className="bg-gray-200 text-left sticky top-0 z-40">
              <tr>
                <th className="p-2 sticky left-0 bg-gray-200 z-50">Company</th>
                <th className="p-2 text-left">Issue Type</th>
                {renderSortableHeader('Effective Date', 'date', 'forthcomingListing')}
                <th className="p-2 text-left">Special PreOpen</th>
                <th className="p-2 text-left">Attachment</th>
              </tr>
            </thead>
            <tbody>
              {sortedForthcomingListingData.map((item, idx) => (
                <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-100'}>
                  <td className="p-2 sticky left-0 bg-inherit z-10 font-medium">{item.companyName || '—'}</td>
                  <td className="p-2">{item.series || '—'}</td>
                  <td className="p-2">{formatDate(item.effectiveDate)}</td>
                  <td className="p-2">{item.specialPreOpen || '—'}</td>
                  <td className="p-2">
                    {item.shdAttachment ? (
                      <a
                        href={item.shdAttachment}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline"
                      >
                        View PDF
                      </a>
                    ) : (
                      '—'
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
      )}

      {activeTab === 'forthcomingOfs' && (
        <div className="overflow-x-auto">
          <table className="table-auto border-collapse w-full text-sm text-gray-800 font-normal">
            <thead className="bg-gray-200 text-left sticky top-0 z-40">
              <tr>
                <th className="p-2 sticky left-0 bg-gray-200 z-50">Symbol</th>
                <th className="p-2 text-left">Company</th>
                <th className="p-2 text-left">Type</th>
                <th className="p-2 text-left">Start Date</th>
                {renderSortableHeader('Closing Date', 'date', 'forthcomingOfs')}
                <th className="p-2 text-left">Floor Price</th>
                <th className="p-2 text-left">Last Price</th>
                {renderSortableHeader('Total Size', 'totalSize', 'forthcomingOfs')}
              </tr>
            </thead>
            <tbody>
              {sortedForthcomingOfsData.map((row, idx) => (
                <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-100'}>
                  <td className="p-2 sticky left-0 bg-inherit z-10 font-medium">
                    <a
                      href={`symbol/${row.symbol}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 underline"
                    >
                      {row.symbol || '—'}
                    </a>
                  </td>
                  <td className="p-2">{row.companyName || '—'}</td>
                  <td className="p-2">{row.series || '—'}</td>
                  <td className="p-2">{formatDate(row.startDate)}</td>
                  <td className="p-2">{formatDate(row.endDate)}</td>
                  <td className="p-2">{row.floorPrice}</td>
                  <td
                    className={`p-2 ${
                      parseFloat(row.currentPrice) > parseFloat(row.floorPrice)
                        ? "text-green-600"
                        : "text-red-600"
                    }`}
                  >
                    {row.currentPrice}
                  </td>
                  <td className="p-2 font-medium">
                    {(() => {
                      const size = parseFloat((row.issueSize || '').toString().replace(/,/g, ''));
                      const price = parseFloat((row.floorPrice || '').toString().replace(/,/g, ''));

                      if (!isNaN(size) && !isNaN(price)) {
                        const total = (size * price) / 1e7;
                        return `₹${total.toFixed(2)} Cr`;
                      }
                      return '—';
                    })()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* 🔹 Upcoming Tenders */}
      {activeTab === 'upcomingTender' && (
        <div className="overflow-x-auto">
          <table className="table-auto border-collapse w-full text-sm text-gray-800 font-normal">
            <thead className="bg-gray-200 text-left sticky top-0 z-40">
              <tr>
                <th className="p-2 sticky left-0 bg-gray-200 z-50">Company</th>
                <th className="p-2 text-left">Series</th>
                <th className="p-2 text-left">Offer Type</th>
                <th className="p-2 text-left">Issue Type</th>
                <th className="p-2 text-left">Start Date</th>
                {renderSortableHeader('Closing Date', 'date', 'upcomingTender')}
                <th className="p-2 text-left">Floor Price</th>
                <th className="p-2 text-left">Last Price</th>
                {renderSortableHeader('Total Size', 'totalSize', 'upcomingTender')}
              </tr>
            </thead>
            <tbody>
              {sortedUpcomingTenderData.map((row, idx) => (
                <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-100'}>
                  <td className="p-2 sticky left-0 bg-inherit z-10 font-medium">
                    <a
                      href={`symbol/${row.symbol}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 underline"
                    >
                      {row.company || '—'}
                    </a>
                  </td>
                  <td className="p-2">{row.series || '—'}</td>
                  <td className="p-2">{row.offerType || '—'}</td>
                  <td className="p-2">{row.issueType || '—'}</td>
                  <td className="p-2">{formatDate(row.todStartDate)}</td>
                  <td className="p-2">{formatDate(row.todEndDate)}</td>
                  <td className="p-2">{row.band}</td>
                  <td
                    className={`p-2 ${
                      parseFloat(row.currentPrice) > parseFloat(row.band)
                        ? "text-green-600"
                        : "text-red-600"
                    }`}
                  >
                    {row.currentPrice}
                  </td>
                  <td className="p-2 font-medium">
                    {(() => {
                      const size = parseFloat((row.issueSize || '').toString().replace(/,/g, ''));
                      const price = parseFloat((row.band || '').toString().replace(/,/g, ''));

                      if (!isNaN(size) && !isNaN(price)) {
                        const total = (size * price) / 1e7;
                        return `₹${total.toFixed(2)} Cr`;
                      }
                      return '—';
                    })()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* 🔹 Economic Calender */}
      {activeTab === 'economicCalender' && (
        <>
          {/* Holidays Link */}
        <div className="mb-3 p-3 bg-yellow-50 border border-yellow-200 rounded text-sm w-[330px]">
          📅 Market holidays List :{" "}
          <a
            href="https://www.nseindia.com/resources/exchange-communication-holidays"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline font-medium"
          >
            NSE Holiday Calendar
          </a>
        </div>
        <div className="overflow-x-auto">
          <table className="table-auto border-collapse w-full text-sm text-gray-800 font-normal">
          <thead className="bg-gray-200 text-left sticky top-0 z-40">
            <tr>
              <th className="p-2 sticky left-0 bg-gray-200 z-50 ">Title</th>
              <th className="p-2 text-left">Date</th>
              <th className="p-2 text-left">Country</th>
              <th className="p-2 text-left">Impact</th>
              <th className="p-2 text-left">Actual</th>
              <th className="p-2 text-left">Expected</th>
              <th className="p-2 text-left">Previous</th>
            </tr>
          </thead>
          <tbody>
            {sortedEconomicCalenderData.map((row, idx) => {
              const rowKey = row.id ?? idx;
              const impactKey = (row.impact || "").toLowerCase();
              const impactChip =
                row.impact ? (
                  <span
                    className={`inline-flex items-center justify-center w-16 h-6 rounded text-xs font-semibold ${
                      impactClasses[impactKey] || "bg-gray-100 text-gray-800"
                    }`}
                  >
                    {row.impact}
                  </span>
                ) : (
                  "—"
                );

              return (
                <React.Fragment key={rowKey}>
                  {/* main row */}
                  <tr className={idx % 2 === 0 ? "bg-white" : "bg-gray-100"}>
                    <td className="p-2 sticky left-0 bg-inherit z-10 font-medium">
                      <div className="flex items-start gap-2">
                        <button
                          onClick={() => toggleRow(rowKey)}
                          className="inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-blue-600 border border-blue-600 rounded"
                        >
                          {expandedRow === rowKey ? "−" : "+"}
                        </button>
                        <span className="flex-1">
                          {row.title || "—"}
                        </span>
                      </div>
                    </td>
                    <td className="p-2">{formatDate(row.date)}</td>
                    <td className="p-2">
                      <span className="mr-1">{flagMap[row.country] || ""}</span>
                      {row.country || "—"}
                    </td>
                    <td className="p-2">{impactChip}</td>
                    <td className="p-2">{row.actual || "—"}</td>
                    <td className="p-2">{row.expected || "—"}</td>
                    <td className="p-2">{row.previous || "—"}</td>
                  </tr>

                  {/* details row */}
                  {expandedRow === rowKey && row.description && (
                    <tr className={idx % 2 === 0 ? "bg-white" : "bg-gray-100"}>
                      <td
                        className="p-2 pl-8 text-sm text-gray-700 align-top"
                        colSpan={7}
                      >
                        {row.description}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
          </table>
        </div>
        </>
      )}

      {/* Price Band Changes */}
      {activeTab === 'priceBandChange' && (
        <div className="overflow-x-auto">
          <table className="table-auto border-collapse w-full text-xs text-gray-800 font-normal">

            <thead className="bg-gray-200 text-left sticky top-0 z-40">
              <tr>
                <th className="px-2 py-1.5 sticky left-0 bg-gray-200 z-50">
                  Symbol
                </th>

                <th className="px-2 py-1.5 text-left">
                  Company
                </th>

                {renderSortableHeader(
                  'M Cap (Cr.)',
                  'marketCap',
                  'priceBandChange'
                )}

                <th className="px-2 py-1.5 text-left">
                  Series
                </th>

                <th className="px-2 py-1.5 text-left">
                  From
                </th>

                <th className="px-2 py-1.5 text-left">
                  To
                </th>

                {renderSortableHeader(
                  'Change',
                  'change',
                  'priceBandChange'
                )}
              </tr>
            </thead>

            <tbody>
              {sortedPriceBandChangeData.map((row, idx) => {

                const from = Number(row["FROM"]);
                const to = Number(row["TO"]);

                const hasValidValues =
                  row["FROM"] != null &&
                  row["TO"] != null &&
                  String(row["FROM"]).trim() !== "" &&
                  String(row["TO"]).trim() !== "" &&
                  Number.isFinite(from) &&
                  Number.isFinite(to);

                const change = hasValidValues
                  ? to - from
                  : null;

                // Market Cap in Crores
                const marketCap = Number(
                  String(row["marketCap"] ?? "").replace(/,/g, "")
                );

                const marketCapCr =
                  Number.isFinite(marketCap) && marketCap > 0
                    ? (marketCap / 1e7).toLocaleString("en-IN", {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                      })
                    : "—";

                const changeColor =
                  change > 0
                    ? "text-green-600"
                    : change < 0
                    ? "text-red-600"
                    : "text-gray-700";

                return (
                  <tr
                    key={`${row["SYMBOL"] || idx}-${idx}`}
                    className={
                      idx % 2 === 0
                        ? "bg-white"
                        : "bg-gray-100"
                    }
                  >

                    {/* Symbol */}
                    <td className="px-2 py-1.5 sticky left-0 bg-inherit z-10 font-medium whitespace-nowrap">
                      <a
                        href={`/symbol/${encodeURIComponent(row["SYMBOL"] || "")}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline"
                      >
                        {row["SYMBOL"] || "—"}
                      </a>
                    </td>

                    {/* Company */}
                    <td className="px-2 py-1.5">
                      {row["SECURITY NAME"] || "—"}
                    </td>

                    {/* Market Cap in Cr */}
                    <td className="px-2 py-1.5 whitespace-nowrap tabular-nums">
                      {marketCapCr}
                    </td>

                    {/* Series */}
                    <td className="px-2 py-1.5">
                      {row["SERIES"] || "—"}
                    </td>

                    {/* Previous Price Band */}
                    <td className="px-2 py-1.5 whitespace-nowrap">
                      {hasValidValues ? `${from}%` : "—"}
                    </td>

                    {/* New Price Band */}
                    <td className={`px-2 py-1.5 font-medium whitespace-nowrap ${changeColor}`}>
                      {hasValidValues ? `${to}%` : "—"}
                    </td>

                    {/* Change in Percentage Points */}
                    <td className={`px-2 py-1.5 font-semibold whitespace-nowrap ${changeColor}`}>
                      {change != null
                        ? `${change > 0 ? "+" : ""}${change} pp`
                        : "—"}
                    </td>

                  </tr>
                );
              })}

              {sortedPriceBandChangeData.length === 0 && (
                <tr>
                  <td
                    colSpan={7}
                    className="px-2 py-4 text-center text-gray-500"
                  >
                    No price band changes found.
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>
      )}

      {activeTab === 'seriesChange' && (
        <div className="w-full">

          {/* NSE Series Information Bar - Always Visible */}
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 mb-3 px-3 py-2 bg-blue-50 border border-blue-100 rounded-lg text-xs text-gray-700">
            <span className="font-semibold text-gray-600">
              NSE Series:
            </span>

            {[
              { code: "EQ", label: "Normal Equity" },
              { code: "SM", label: "SME Equity" },
              { code: "BE", label: "Trade-to-Trade (Market Surveillance)" },
              { code: "BZ", label: "Trade-to-Trade (Regulatory Non-Compliance)" },
              { code: "ST", label: "SME Trade-to-Trade" },
            ].map((item) => (
              <span
                key={item.code}
                className="inline-flex items-center gap-1.5"
              >
                <span className="font-bold text-blue-700">
                  {item.code}
                </span>
                <span className="text-gray-600">
                  - {item.label}
                </span>
              </span>
            ))}
          </div>

          {/* Series Changes Table */}
          <div className="overflow-x-auto">
            <table className="table-auto border-collapse w-full text-sm text-gray-800 font-normal">

              <thead className="bg-gray-200 text-left sticky top-0 z-40">
                <tr>
                  <th className="p-2 sticky left-0 bg-gray-200 z-50">
                    Symbol
                  </th>

                  <th className="p-2 text-left">
                    Company
                  </th>

                  <th className="p-2 text-left">
                    From Series
                  </th>

                  <th className="p-2 text-left">
                    To Series
                  </th>

                  <th className="p-2 text-left">
                    Change Date
                  </th>

                  <th className="p-2 text-left">
                    Remarks
                  </th>
                </tr>
              </thead>

              <tbody>
                {seriesChangeData.map((row, idx) => {
                  const fromSeries = String(row["FROM SERIES"] || "").trim();
                  const toSeries = String(row["TO SERIES"] || "").trim();

                  const isMovedToEQ = toSeries === "EQ";
                  const isMovedFromEQ = fromSeries === "EQ" && toSeries !== "EQ";

                  const seriesColor = isMovedToEQ
                    ? "text-green-600"
                    : isMovedFromEQ
                    ? "text-red-600"
                    : "text-gray-700";

                  return (
                    <tr
                      key={`${row["SYMBOL"] || idx}-${idx}`}
                      className={idx % 2 === 0 ? "bg-white" : "bg-gray-100"}
                    >

                      {/* Symbol */}
                      <td className="p-2 sticky left-0 bg-inherit z-10 font-medium">
                        <a
                          href={`/symbol/${encodeURIComponent(row["SYMBOL"] || "")}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 underline"
                        >
                          {row["SYMBOL"] || "—"}
                        </a>
                      </td>

                      {/* Company */}
                      <td className="p-2">
                        {row["SECURITY"] || "—"}
                      </td>

                      {/* Previous Series */}
                      <td className="p-2">
                        {fromSeries || "—"}
                      </td>

                      {/* New Series */}
                      <td className={`p-2 font-semibold ${seriesColor}`}>
                        {toSeries || "—"}
                      </td>

                      {/* Effective Date */}
                      <td className="p-2 whitespace-nowrap">
                        {row["CHANGE DATE"] || "—"}
                      </td>

                      {/* Remarks */}
                      <td className="p-2">
                        {row["REMARKS"] || "—"}
                      </td>

                    </tr>
                  );
                })}

                {seriesChangeData.length === 0 && (
                  <tr>
                    <td
                      colSpan={6}
                      className="p-4 text-center text-gray-500"
                    >
                      No series changes found.
                    </td>
                  </tr>
                )}
              </tbody>

            </table>
          </div>
        </div>
      )}

      {activeTab === 'creditRating' && (
        <div className="w-full">

          {/* Credit Rating Information Bar - Always Visible */}
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 mb-3 px-3 py-2 bg-blue-50 border border-blue-100 rounded-lg text-xs text-gray-700">
            <span className="font-semibold text-gray-600">
              Credit Ratings:
            </span>

            {[
              { code: "AAA", label: "Highest Safety", color: "text-green-700" },
              { code: "AA", label: "High Safety", color: "text-green-600" },
              { code: "A", label: "Adequate Safety", color: "text-blue-700" },
              { code: "BBB", label: "Moderate Safety", color: "text-yellow-700" },
              { code: "BB", label: "Moderate Default Risk", color: "text-orange-600" },
              { code: "B", label: "High Default Risk", color: "text-red-600" },
              { code: "D", label: "Default", color: "text-red-800" },
            ].map((item) => (
              <span
                key={item.code}
                className="inline-flex items-center gap-1.5"
              >
                <span className={`font-bold ${item.color}`}>
                  {item.code}
                </span>
                <span className="text-gray-600">
                  - {item.label}
                </span>
              </span>
            ))}
          </div>

          {/* Credit Ratings Table */}
          <div className="overflow-x-auto">
            <table className="table-auto border-collapse w-full text-sm text-gray-800 font-normal">

              <thead className="bg-gray-200 text-left sticky top-0 z-40">
                <tr>
                  <th className="p-2 sticky left-0 bg-gray-200 z-50">
                    Symbol
                  </th>
                  <th className="p-2">Company</th>
                  <th className="p-2">Agency</th>
                  <th className="p-2">Rating</th>
                  <th className="p-2">Outlook</th>
                  <th className="p-2">Action</th>
                  <th className="p-2">Rating Type</th>
                  <th className="p-2">Facility</th>
                  <th className="p-2">Amount (Cr.)</th>
                  <th className="p-2">Rating Date</th>
                  <th className="p-2">Broadcast Date</th>
                  <th className="p-2">1D %</th>
                  <th className="p-2">1W %</th>
                  <th className="p-2">Report</th>
                </tr>
              </thead>

              <tbody>
                {creditRatingData.map((row, idx) => {

                  const rating = String(row.creditRating || "").toUpperCase();
                  const outlook = String(row.outlook || "").trim();
                  const action = String(row.currentAction || "").trim();

                  // Extract long-term rating grade
                  const ratingMatch = rating.match(
                    /(?:AAA|AA|BBB|BB|A|B|CCC|CC|C|D)(?:[+-])?(?![A-Z0-9])/
                  );

                  const ratingGrade = ratingMatch?.[0] || "";

                  const ratingColor =
                    ratingGrade.startsWith("AAA") ? "text-green-700" :
                    ratingGrade.startsWith("AA") ? "text-green-600" :
                    ratingGrade.startsWith("A") ? "text-blue-700" :
                    ratingGrade.startsWith("BBB") ? "text-yellow-700" :
                    ratingGrade.startsWith("BB") ? "text-orange-600" :
                    ratingGrade.startsWith("B") ? "text-red-600" :
                    ratingGrade ? "text-red-800" :
                    "text-gray-700";

                  const outlookColor =
                    /positive/i.test(outlook) ? "text-green-600" :
                    /negative/i.test(outlook) ? "text-red-600" :
                    "text-gray-700";

                  const actionColor =
                    /upgrade/i.test(action) ? "text-green-600" :
                    /downgrade/i.test(action) ? "text-red-600" :
                    "text-gray-700";

                  const formatChange = (value) => {
                    if (value === null || value === undefined || value === "") {
                      return <span className="text-gray-400">—</span>;
                    }

                    const num = Number(value);
                    if (!Number.isFinite(num)) return "—";

                    return (
                      <span className={
                        num > 0 ? "text-green-600" :
                        num < 0 ? "text-red-600" :
                        "text-gray-600"
                      }>
                        {num > 0 ? "+" : ""}{num.toFixed(2)}%
                      </span>
                    );
                  };

                  return (
                    <tr
                      key={row.hash || `${row.symbol}-${idx}`}
                      className={idx % 2 === 0 ? "bg-white" : "bg-gray-100"}
                    >

                      {/* Symbol */}
                      <td className="p-2 sticky left-0 bg-inherit z-10 font-medium whitespace-nowrap">
                        <a
                          href={`/symbol/${encodeURIComponent(row.symbol || "")}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 underline"
                        >
                          {row.symbol || "—"}
                        </a>
                      </td>

                      {/* Company */}
                      <td className="p-2 min-w-[180px]">
                        {row.companyName || "—"}
                      </td>

                      {/* Agency */}
                      <td className="p-2 whitespace-nowrap">
                        {row.creditAgencyName || "—"}
                      </td>

                      {/* Credit Rating */}
                      <td className={`p-2 font-semibold whitespace-nowrap ${ratingColor}`}>
                        {row.creditRating || "—"}
                      </td>

                      {/* Outlook */}
                      <td className={`p-2 font-medium ${outlookColor}`}>
                        {outlook || "—"}
                      </td>

                      {/* Current Action */}
                      <td className={`p-2 font-semibold whitespace-nowrap ${actionColor}`}>
                        {action || "—"}
                      </td>

                      {/* Rating Type */}
                      <td className="p-2 whitespace-nowrap">
                        {row.typeOfRating || "—"}
                      </td>

                      {/* Facility */}
                      <td className="p-2 min-w-[200px]">
                        {row.ratingAssigned || "—"}
                      </td>

                      {/* Amount */}
                      <td className="p-2 text-right whitespace-nowrap">
                        {row.amount !== "" &&
                        row.amount !== null &&
                        row.amount !== undefined &&
                        Number.isFinite(Number(row.amount))
                          ? Number(row.amount).toLocaleString("en-IN", {
                              maximumFractionDigits: 2
                            })
                          : "—"}
                      </td>

                      {/* Rating Date */}
                      <td className="p-2 whitespace-nowrap">
                        {row.dateOfCurrentCredit || "—"}
                      </td>

                      {/* Broadcast Date */}
                      <td className="p-2 whitespace-nowrap">
                        {row.broadcastDateTime || "—"}
                      </td>

                      {/* 1D Change */}
                      <td className="p-2 text-right whitespace-nowrap">
                        {formatChange(row.change_1D)}
                      </td>

                      {/* 1W Change */}
                      <td className="p-2 text-right whitespace-nowrap">
                        {formatChange(row.change_1W)}
                      </td>

                      {/* Rating Report */}
                      <td className="p-2">
                        {/^https?:\/\//i.test(row.detailsOfRatingLink || "") ? (
                          <a
                            href={row.detailsOfRatingLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 underline whitespace-nowrap"
                          >
                            View
                          </a>
                        ) : (
                          "—"
                        )}
                      </td>

                    </tr>
                  );
                })}

                {creditRatingData.length === 0 && (
                  <tr>
                    <td
                      colSpan={14}
                      className="p-4 text-center text-gray-500"
                    >
                      No credit ratings found.
                    </td>
                  </tr>
                )}
              </tbody>

            </table>
          </div>
        </div>
      )}

    </div>
  );
}

export default UpcomingEvents;
